import * as React from "react"

const MOBILE_BREAKPOINT = 1024

function checkIsMobile(): boolean {
  if (typeof window === "undefined") return false;
  const isSmallScreen = window.innerWidth < MOBILE_BREAKPOINT;
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isTouchDevice = ('ontouchstart' in window || navigator.maxTouchPoints > 0) && window.innerWidth < 1200;
  return isSmallScreen || isMobileUA || isTouchDevice;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(checkIsMobile)

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(checkIsMobile())
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return isMobile
}
